import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'

import { UserService } from '../services/user.service';
import { IndustryService } from '../services/industry.service'
import { fadeInUp } from '../services/animations/fadeInUp.animation'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    animations: [fadeInUp]
})
export class HomePageComponent implements OnInit, OnDestroy {

	isLoggedIn: Boolean = false
	loginRedirectPath: String = ''
	industries: any
    industriesSubscription: any
    randomProvider: any
    users: any

    constructor(
		private router: Router,
		private userService: UserService,
        private industryService: IndustryService
    ) {
        if (!this.users) {
            this.users = {}
        }
     }

    ngOnInit() {
		this.isLoggedIn = this.userService.isLoggedin()
        this.industryService.getIndustries()
        this.industriesSubscription = this.industryService.Industries.subscribe(industries => {
            if (industries && industries.length > 0) {
                this.industries = industries
            }
        })
        this.getRandomProvider()
    }

    ngOnDestroy() {
        if (this.industriesSubscription) {
            this.industriesSubscription.unsubscribe()
        }
    }

    getRandomProvider() {
        this.industryService.getRandomProvider().subscribe(response => {
            let resData = response.json()
            if (resData && resData.length > 0) {
                this.randomProvider = resData[0]
                const data = this.randomProvider.data
                if (data.length > 0) {
                    let studentCount = 0
                    let studentTotal = 0
                    let employerCount = 0
                    let employerTotal = 0
                    data.forEach(user => {
                        if (user.userType === 'Student') {
                            studentCount++
                            let score = parseFloat(user.score)
                            studentTotal += score
                        } else {
                            employerCount++
                            let score = parseFloat(user.score)
                            employerTotal += score
                        }
                    })
                    if (studentCount > 0) {
                        let avg = studentTotal / studentCount
                        this.users['student'] = avg.toFixed(1)
                    }
                    if (employerCount > 0) {
                        let avg = employerTotal / employerCount
                        this.users['employer'] = avg.toFixed(1)
                    }
                }
            }
        }, err => {
            console.log(err)
        })
    }

	seeAllReviews(link: String) {
		if (this.isLoggedIn) {
			this.router.navigate(['/course/' + link])
		} else {
			this.loginRedirectPath = '/course/' + link
			setTimeout(function () {
				document.getElementById('notloggedin-overlay').classList.add('is-block')
			}, 10)
			setTimeout(function () {
				document.getElementById('notloggedin-overlay').classList.add('is-visible')
			}, 20)
		}
	}

	redirectToLogin(route, queryParams) {
		const routes = []
		routes.push(route)
		if (queryParams) {
			this.router.navigate(routes, { queryParams: { redirect: this.loginRedirectPath } })
		} else {
			this.router.navigate(routes)
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts